import React from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { handOffState, vatAccountReviewDescriptor } from '../../../../context/TaskContextDescriptor';

/**
 * The assistant is a company route — /:companyId/ai-assistant — like every
 * other hand-off (BankhandelserPage, ViewInvoice, TaxStep, the sidebar). The
 * link used to go to /ai-assistant, which matches no route.
 */
function resolveCompanyId(explicit, params) {
    if (explicit) return String(explicit);
    if (params?.companyId) return String(params.companyId);
    try {
        const stored = JSON.parse(window.localStorage.getItem('selectedCompany') || 'null');
        return stored?.companyId ? String(stored.companyId) : null;
    } catch {
        return null;
    }
}

function Navigation({ descriptor, companyId }) {
    const location = useLocation();
    const params = useParams();
    const resolved = resolveCompanyId(companyId, params);
    if (!resolved) return null;
    return <Link aria-label="Fråga AI om detta" className="small d-inline-block mt-2" to={{ pathname: `/${resolved}/ai-assistant`,
        state: handOffState(descriptor, {
            prefillMessage: 'Kan du förklara momsbehandlingen för det här kontot utifrån det kontrollerade underlaget? Beskriv vad som är säkert, vad som behöver kontrolleras och hänvisa till källorna. Gör inga ändringar.',
            taskReturnPath: `${location.pathname}${location.search || ''}`,
        }) }} title="Öppnar en redigerbar fråga med kontot och perioden som kontext. Ingenting skickas förrän du väljer Skicka.">
        Fråga AI om detta
    </Link>;
}

export default function VatAskAILink({ accountId, accountNumber, fiscalYearId, vatPeriodId, companyId = null }) {
    const descriptor = vatAccountReviewDescriptor({ accountId, accountNumber, fiscalYearId, vatPeriodId });
    return descriptor ? <Navigation descriptor={descriptor} companyId={companyId} /> : null;
}
